var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { Button, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { NO_PARAMETER, describeVolume, formatVolumeDate, } from "../../utils/volumeWindow";
import css from "./PreviewModal.module.css";
var ChangeList = function (_a) {
    var headingId = _a.headingId, changes = _a.changes, itemId = _a.itemId, warning = _a.warning;
    var formatMessage = useIntl().formatMessage;
    if (changes.length === 0)
        return null;
    return (React.createElement("div", { className: css.section },
        React.createElement("p", { className: warning ? css.deleteWarning : undefined }, formatMessage({ id: headingId }, { count: changes.length })),
        React.createElement("ul", { className: css.list }, changes.map(function (change) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (React.createElement("li", { key: "".concat((_a = change.issueId) !== null && _a !== void 0 ? _a : "", "-").concat((_b = change.expectedDate) !== null && _b !== void 0 ? _b : "", "-").concat((_d = (_c = change.newLabel) !== null && _c !== void 0 ? _c : change.label) !== null && _d !== void 0 ? _d : "") },
                formatMessage({ id: itemId }, {
                    label: (_f = (_e = change.label) !== null && _e !== void 0 ? _e : change.newLabel) !== null && _f !== void 0 ? _f : "—",
                    newLabel: (_h = (_g = change.newLabel) !== null && _g !== void 0 ? _g : change.label) !== null && _h !== void 0 ? _h : "—",
                    date: change.expectedDate
                        ? formatVolumeDate(change.expectedDate)
                        : "—",
                    reason: change.reason
                        ? formatMessage({
                            id: "ui-br-legaldeposits.schedule.preview.reason.".concat(change.reason),
                        })
                        : NO_PARAMETER,
                }),
                change.engaged && (React.createElement("strong", { className: css.engagedMark }, formatMessage({
                    id: "ui-br-legaldeposits.schedule.preview.item.engaged",
                })))));
        }))));
};
export var PreviewModal = function (_a) {
    var open = _a.open, preview = _a.preview, stale = _a.stale, errorMessage = _a.errorMessage, onConfirm = _a.onConfirm, onCancel = _a.onCancel, isPending = _a.isPending;
    var formatMessage = useIntl().formatMessage;
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", onClick: onConfirm, disabled: isPending || !preview }, formatMessage({ id: "ui-br-legaldeposits.schedule.preview.confirm" })),
        React.createElement(Button, { onClick: onCancel, disabled: isPending }, formatMessage({ id: "ui-br-legaldeposits.schedule.preview.cancel" }))));
    var engagedTouched = useMemo(function () {
        return preview
            ? __spreadArray(__spreadArray([], preview.renumbered, true), preview.kept, true).filter(function (change) { return change.engaged; }).length
            : 0;
    }, [preview]);
    var nothingChanges = !!preview &&
        preview.toCreate.length === 0 &&
        preview.toDelete.length === 0 &&
        preview.renumbered.length === 0;
    return (React.createElement(Modal, { open: open, size: "medium", label: formatMessage({
            id: "ui-br-legaldeposits.schedule.preview.title",
        }), footer: footer, onClose: onCancel },
        stale && (React.createElement(MessageBanner, { type: "warning" }, formatMessage({ id: "ui-br-legaldeposits.schedule.preview.stale" }))),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage)),
        preview && (React.createElement("div", null,
            React.createElement("p", null, formatMessage({ id: "ui-br-legaldeposits.schedule.preview.header" }, {
                volume: describeVolume({
                    label: preview.volumeLabel,
                    startDate: preview.volumeStartDate,
                    endDate: preview.volumeEndDate,
                }),
            })),
            React.createElement("p", null, formatMessage({ id: "ui-br-legaldeposits.schedule.preview.unchanged" }, { count: preview.unchanged })),
            nothingChanges && (React.createElement("p", null, formatMessage({
                id: "ui-br-legaldeposits.schedule.preview.nothingChanges",
            }))),
            React.createElement(ChangeList, { headingId: "ui-br-legaldeposits.schedule.preview.toCreate", itemId: "ui-br-legaldeposits.schedule.preview.item.create", changes: preview.toCreate }),
            React.createElement(ChangeList, { headingId: "ui-br-legaldeposits.schedule.preview.toDelete", itemId: "ui-br-legaldeposits.schedule.preview.item.delete", changes: preview.toDelete }),
            preview.toDeleteEngaged > 0 && (React.createElement("p", { className: css.deleteWarning }, formatMessage({ id: "ui-br-legaldeposits.schedule.preview.toDeleteEngaged" }, { count: preview.toDeleteEngaged }))),
            engagedTouched > 0 && (React.createElement("p", { className: css.deleteWarning }, formatMessage({ id: "ui-br-legaldeposits.schedule.preview.engagedTouched" }, { count: engagedTouched }))),
            React.createElement(ChangeList, { headingId: "ui-br-legaldeposits.schedule.preview.renumbered", itemId: "ui-br-legaldeposits.schedule.preview.item.renumbered", changes: preview.renumbered }),
            React.createElement(ChangeList, { headingId: "ui-br-legaldeposits.schedule.preview.kept", itemId: "ui-br-legaldeposits.schedule.preview.item.kept", changes: preview.kept })))));
};
